import { useState } from "react";
import { GripVertical, X, ListMusic, Trash2 } from "lucide-react";
import { fmtTime } from "@/lib/api";

export const QueuePanel = ({ state, act }) => {
  const queue = state?.queue || [];
  const [drag, setDrag] = useState(null);
  const [over, setOver] = useState(null);

  const drop = (target) => {
    if (drag === null || drag === target) return;
    const ids = queue.map((q) => q.qid);
    const [moved] = ids.splice(drag, 1);
    ids.splice(target, 0, moved);
    act("put", "/studio/queue", { qids: ids });
  };

  return (
    <section className="panel p-5 flex flex-col gap-3 min-w-0 xl:row-span-1" data-testid="studio-queue-panel">
      <div className="flex items-center justify-between">
        <div>
          <span className="eyebrow">Queue</span>
          <h3 className="font-display text-3xl chrome-text">Up next</h3>
        </div>
        <button onClick={() => act("delete", "/studio/queue")} disabled={!queue.length} className="text-xs font-mono flex items-center gap-1 text-[color:var(--lr-muted)] hover:text-[color:var(--red)] disabled:opacity-40" data-testid="studio-queue-clear-button">
          <Trash2 className="w-3.5 h-3.5" /> Clear
        </button>
      </div>
      {!queue.length && (
        <div className="flex flex-col items-center gap-2 py-10 text-center text-[color:var(--lr-muted)]" data-testid="studio-queue-empty">
          <ListMusic className="w-8 h-8" />
          <p className="text-sm">Queue is empty. Turn on Auto DJ or add tracks from the library.</p>
        </div>
      )}
      <ol className="flex flex-col gap-2 overflow-y-auto max-h-[520px] pr-1" data-testid="studio-queue-list">
        {queue.map((t, i) => (
          <li key={t.qid} draggable
            onDragStart={() => setDrag(i)} onDragEnd={() => { setDrag(null); setOver(null); }}
            onDragOver={(e) => { e.preventDefault(); setOver(i); }} onDrop={() => drop(i)}
            className={`queue-row flex items-center gap-3 rounded-lg border border-white/10 bg-black/30 px-3 py-2.5 cursor-grab ${drag === i ? "dragging" : ""} ${over === i && drag !== i ? "drag-over" : ""}`}
            data-testid={`studio-queue-item-${i}`}>
            <GripVertical className="w-4 h-4 text-white/30 shrink-0" />
            <span className="font-mono text-xs text-[color:var(--gold)] w-5">{i + 1}</span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold">{t.title}</p>
              <p className="truncate text-xs text-[color:var(--lr-muted)]">{t.artist || "Unknown artist"}</p>
            </div>
            <span className="font-mono text-xs text-[color:var(--lr-muted)]">{fmtTime(t.duration)}</span>
            <button onClick={() => act("delete", `/studio/queue/${t.qid}`)} className="text-white/40 hover:text-[color:var(--red)]" aria-label="Remove" data-testid={`studio-queue-remove-${i}`}>
              <X className="w-4 h-4" />
            </button>
          </li>
        ))}
      </ol>
      <p className="text-xs text-[color:var(--lr-muted)]">Drag to reorder.</p>
    </section>
  );
};
